/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button, Select } from "antd";
import { updateJackpot, getJackpot } from "../../features/jackpot/jackpotSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const EditJackpot = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, jackpot } = useSelector(
    (state) => state.jackpot
  );
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const data = { ...values };
    data.type = "hole-in-one";
    dispatch(updateJackpot({ id, data }));
  };

  useEffect(() => {
    loadJackpot();
  }, []);

  useEffect(() => {
    if (jackpot) {
      form.setFieldsValue({
        name: jackpot.name,
        entry_price: jackpot.entry_price || 0,
        winning_price: jackpot.winning_price,
        description: jackpot.description,
        points: jackpot.points,
        status: jackpot.status?.toString(),
        type: jackpot.type,
        prize_type: jackpot.prize_type || "cash",
        winning_item: jackpot.winning_item,
      });
      setPrizeType(jackpot.prize_type || "cash");
    }
  }, [jackpot]);

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "Setting is updated successfully",
      });
      navigate("/admin/hole-in-one-prize");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadJackpot = () => {
    dispatch(getJackpot(id));
  };

  const [prizeType, setPrizeType] = useState(jackpot?.prize_type || "cash");

  const handlePrizeTypeChange = (value) => {
    setPrizeType(value);
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Challenge</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Prize Type"
          name="prize_type"
          rules={[{ required: true, message: "Please select the prize type!" }]}
        >
          <Select onChange={handlePrizeTypeChange}>
            <Option value="cash">Cash</Option>
            <Option value="item">Item</Option>
          </Select>
        </Form.Item>

        {prizeType === "item" ? (
          <Form.Item
            label="Winning Item"
            name="winning_item"
            rules={[
              { required: true, message: "Please input the winning item!" },
            ]}
          >
            <Input />
          </Form.Item>
        ) : (
          <Form.Item
            label="Winning Price"
            name="winning_price"
            rules={[
              { required: true, message: "Please input the winning price!" },
            ]}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        )}

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please input the description!" }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Points"
          name="points"
          rules={[{ required: true, message: "Please input the points!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>
                
        <Form.Item
          label="Entry Price"
          name="entry_price"
          rules={[{ required: false, message: 'Please input the entry price!' }]}
        >
          <InputNumber min={1} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditJackpot;
